import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ContentCard } from "@/pages/HomeApp";

export default function Favorites() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/favorites").then(({ data }) => setItems(data.favorites)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-8">
      <h1 className="text-3xl font-extrabold text-[#243B53]">Meus Favoritos</h1>
      <p className="text-[#243B53]/70">Conteúdos que você salvou para ver depois.</p>
      {items.length === 0 ? (
        <div className="mt-10 card-soft p-10 text-center">
          <div className="text-5xl">💛</div>
          <div className="mt-3 font-bold text-[#243B53]">Nenhum favorito ainda.</div>
          <div className="text-sm text-[#243B53]/60">Abra um conteúdo e toque em SALVAR.</div>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((c) => <ContentCard key={c.id} content={c} />)}
        </div>
      )}
    </div>
  );
}
